// extracted by mini-css-extract-plugin
export default {"button":"DashboardPassportFileEditorItem_button__Ziwo8"};